import React from 'react'
import { getSettings } from '../../../graphql/settings'
import { withApollo } from '@apollo/client/react/hoc'
import compose from '../../../utils/functions'

// Components imports
import NotificationList from '../../../components/notification_list'
import AppointmentsList from '../../../components/appointment_list'

// Design imports
import { Button, Divider, Grid, Paper, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import UsualActionsIcon from '@material-ui/icons/BookmarkBorder'
import WarningIcon from '@material-ui/icons/Warning'
import NotificationIcon from '@material-ui/icons/Notifications'
import styles from './styles'

class Home extends React.Component {
    state = {
        tsMessage: '',
    }

    componentDidMount() {
        this.fetchSettings()
    }

    fetchSettings = () => {
        const { client } = this.props
        client.query(getSettings()).then((result) => {
            if (result.data && result.data.getSettings) {
                this.setState({ tsMessage: result.data.getSettings.tsMessage || '' })
            }
        })
    }

    goToNewAppointment = () => {
        this.props.history.push('/new-appointment')
    }

    goToNewPatient = () => {
        this.props.history.push('/new-patient')
    }

    goToNewIncidence = () => {
        this.props.history.push('/new-incidence')
    }

    render() {
        const { classes } = this.props
        const { tsMessage } = this.state

        return (
            <div className={classes.root}>
                <Grid container spacing={24}>
                    <Grid item xs={12} sm={12} md={6}>
                        <Grid container spacing={24}>
                            <Grid item xs={12}>
                                <Paper>
                                    <div className={classes.cardHeader}>
                                        <div className={classes.cardTitleContainer}>
                                            <UsualActionsIcon color="primary" style={{ fontSize: 28 }} />
                                            <Typography className={classes.title} variant="h6" color="primary">
                                                Accions més habituals
                                            </Typography>
                                        </div>
                                    </div>
                                    <Divider />
                                    <Grid container spacing={16} className={classes.cardContainer} alignItems="stretch">
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Button
                                                fullWidth
                                                variant="outlined"
                                                color="primary"
                                                className={classes.quickActionButton}
                                                classes={{ label: classes.label }}
                                                onClick={() => this.goToNewAppointment()}>
                                                Demanar hora
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Button
                                                fullWidth
                                                variant="outlined"
                                                color="primary"
                                                className={classes.quickActionButton}
                                                classes={{ label: classes.label }}
                                                onClick={() => this.goToNewPatient()}>
                                                Donar d'alta un nou pacient
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Button
                                                fullWidth
                                                variant="outlined"
                                                color="primary"
                                                className={classes.quickActionButton}
                                                classes={{ label: classes.label }}
                                                onClick={() => this.goToNewIncidence()}>
                                                Nova incidència
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            {tsMessage && tsMessage.trim() !== '' && (
                                <Grid item xs={12}>
                                    <Paper>
                                        <div className={classes.cardHeader}>
                                            <div className={classes.cardTitleContainer}>
                                                <WarningIcon color="secondary" style={{ fontSize: 28 }} />
                                                <Typography className={classes.title} variant="h6" color="secondary">
                                                    Avís sobre peticions de visites
                                                </Typography>
                                            </div>
                                        </div>
                                        <Divider />
                                        <div className={classes.cardContainer}>
                                            <Typography
                                                className={classes.tsMessage}
                                                component="div"
                                                dangerouslySetInnerHTML={{ __html: tsMessage }}
                                            />
                                        </div>
                                    </Paper>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <Grid container spacing={24}>
                            <Grid item xs={12}>
                                <Paper>
                                    <div className={classes.cardHeader}>
                                        <div className={classes.cardTitleContainer}>
                                            <NotificationIcon color="primary" style={{ fontSize: 28 }} />
                                            <Typography className={classes.title} variant="h6" color="primary">
                                                Últimes peticions d'hora
                                            </Typography>
                                        </div>
                                    </div>
                                    <Divider />
                                    <AppointmentsList />
                                </Paper>
                            </Grid>
                            <Grid item xs={12}>
                                <Paper>
                                    <div className={classes.cardHeader}>
                                        <div className={classes.cardTitleContainer}>
                                            <WarningIcon color="primary" style={{ fontSize: 28 }} />
                                            <Typography className={classes.title} variant="h6" color="primary">
                                                Últimes incidencies
                                            </Typography>
                                        </div>
                                    </div>
                                    <Divider />
                                    <NotificationList />
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default compose(withApollo, withStyles(styles))(Home)
